enum GeometryRepresentationOperation { Addition, Deduction }

export default GeometryRepresentationOperation;